export const scrollToTop = () => {
    const rootEle = document.documentElement
    rootEle.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }